import {
  IWorkingDaysAnalyticsActivityEnum,
  IWorkingDaysAnalyticsActivityV2Enum,
} from 'lib/enum/working-days-analytics-activity.enum';

export interface AppMetricsRaw {
  [IWorkingDaysAnalyticsActivityEnum.AverageDurationPerCount]: string;
  [IWorkingDaysAnalyticsActivityEnum.TotalDuration]: string;
  [IWorkingDaysAnalyticsActivityEnum.count]: string;
}

export interface AppMetricsV2Raw {
  [IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.count]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration]: string;
  [IWorkingDaysAnalyticsActivityV2Enum.CallCount]: string;
}
